<template>
  <div class="auth-layout d-flex align-items-center justify-content-center m-0">
    <child />
  </div>
</template>

<script>
export default {
  name: 'AuthLayout'
}
</script>

<style lang="scss">
.auth-layout {
  height: 100vh;
  position: relative;
  background: #0000009E 0% 0% no-repeat padding-box !important;
}
</style>
